import React, { useState } from 'react';
import api from '../api/api';

const Feedback = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', text: '' });

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!message.trim()) {
      setStatus({ type: 'error', text: 'Please share your feedback before submitting.' });
      return;
    }

    setLoading(true);
    setStatus({ type: '', text: '' });

    try {
      await api.post('/student/feedback', { message: message.trim() });
      setMessage('');
      setStatus({
        type: 'success',
        text: 'Feedback sent. If your idea is strong, we will consider building it.'
      });
    } catch (error) {
      setStatus({
        type: 'error',
        text: error.response?.data?.error || 'Failed to send feedback. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 md:px-8 py-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 via-white to-blue-50">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center shadow-md">
              <i className="bx bx-bulb text-2xl"></i>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.28em] text-blue-600 font-semibold">Feedback</p>
              <h1 className="text-3xl font-bold text-gray-900">Help Us Improve</h1>
            </div>
          </div>
          <p className="text-gray-600 max-w-2xl leading-7">
            Tell us what feature you want next. We review good ideas closely, and if your suggestion stands out, you can get rewarded too.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="p-6 md:p-8">
          <label className="block mb-3 text-sm font-semibold text-gray-700">
            What should we build next?
          </label>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Share a feature idea, improvement, or anything that would make RankMySkills more useful for students like you."
            rows={8}
            className="w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />

          {status.text ? (
            <div
              className={`mt-4 rounded-2xl px-4 py-3 text-sm font-medium ${
                status.type === 'success'
                  ? 'bg-green-50 text-green-700 border border-green-200'
                  : 'bg-red-50 text-red-600 border border-red-200'
              }`}
            >
              {status.text}
            </div>
          ) : null}

          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="group relative overflow-hidden rounded-full bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-3 text-white font-semibold shadow-md transition hover:shadow-lg disabled:opacity-70"
            >
              <span className="absolute inset-y-0 -left-10 w-8 rotate-12 bg-white/35 transition-transform duration-1000 group-hover:translate-x-80"></span>
              <span className="relative z-10 flex items-center gap-2">
                <i className="bx bx-send text-lg"></i>
                {loading ? 'Sending...' : 'Send Feedback'}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Feedback;
